export default {
    'The admin team id field is required when to id is not present.' : 'Please select a team to contact'
}